import { render, staticRenderFns } from "./TiersSearch.vue?vue&type=template&id=5bc2850a&"
import script from "./TiersSearch.vue?vue&type=script&lang=js&"
export * from "./TiersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports